import unique from '../../parser/route/unique';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://wx.mlcdn.com.br`,
          `https://6590300.fls.doubleclick.net`,
          `https://a-static.mlcdn.com.br`,
          `https://ad.doubleclick.net`,
          `https://analytics.pangle-ads.com`,
          `https://analytics.tiktok.com`,
          `https://analytics.twitter.com`,
          `https://bat.bing.com`,
          `https://c.bing.com`,
          `https://c.clarity.ms`,
          `https://cas.avalon.perfdrive.com`,
          `https://cdn.perfdrive.com`,
          `https://connect.facebook.net`,
          `https://ct.pinterest.com`,
          `https://d.clarity.ms`,
          `https://gum.criteo.com`,
          `https://i.btg360.com.br`,
          `https://s.pinimg.com`,
          `https://sc-static.net`,
          `https://script.hotjar.com`,
          `https://site-content.magazineluiza.com.br`,
          `https://static.ads-twitter.com`,
          `https://static.criteo.net`,
          `https://static.hotjar.com`,
          `https://t.co`,
          `https://tags.creativecdn.com`,
          `https://td.doubleclick.net`,
          `https://tom.mlcdn.com.br`,
          `https://tr.snapchat.com`,
          `https://tr6.snapchat.com`,
          `https://us.creativecdn.com`,
          `https://www.clarity.ms`,
          `https://www.facebook.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-1': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-script-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-2': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-all-in-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-3': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-criteo-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-4': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-tik-tok-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-5': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-rtbhouse-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-6': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-stewie-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-7': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-8': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      props: {
        id: `4936838`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-hotjar-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-9': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-9`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-10': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-10`,
      spacing: {
      },
      ssr: false,
    },
    'header-event-page-view-dispatcher-11': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-11`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-9-children-page-loading-0': {
      name: `PageLoading`,
      from: `@magalu/ecomm-components/components/PageLoading`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-9-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-state-loader-10-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-10-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col px-md items-center bg-surface-container-lowest`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        as: `h1`,
        title: `Oops!`,
        className: `font-2xlg-bold mt-sm mx-xsm text-on-interaction-default-inverted`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-1': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Achei que essa página também estava por aqui`,
        as: `p`,
        className: `font-2xsm-regular m-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-2': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: props?.route?.asPath,
        as: `p`,
        className: `font-2xsm-bold m-xsm w-[100%] truncate`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-image-3': {
      name: `Image`,
      from: `@magalu/ecomm-components/components/Image`,
      props: {
        src: `https://wx.mlcdn.com.br/site/shared/error/temnomagalu.gif`,
        width: `186`,
        height: `186`,
        alt: `produtos magalu`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-image-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-4': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Mas, espera 🤔`,
        as: `p`,
        className: `font-2xsm-regular m-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-5': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `#TemNoMagalu`,
        as: `p`,
        className: `font-2xsm-bold mb-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-6': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `É só fazer uma nova busca, ou então voltar para a página inicial`,
        as: `p`,
        className: `font-2xsm-regular m-xsm w-[230px] text-center`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-button-7': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        pushToSiteDomain: true,
        href: `/`,
        label: `VOLTAR PARA O INÍCIO`,
        as: `a`,
        className: `font-2xsm-regular mb-lg mt-sm`,
        size: `large`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-button-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-version-tag-0': {
      name: `VersionTag`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `footer-version-tag-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-1': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `footer-back-to-top-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "host": "https://federation.magazineluiza.com.br",
    "timeout": 5000
  }
}

export const getHeadProps = (props) => ({
    links: [
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.woff`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/truetype`,
        fetchpriority: `high`,
        href: `https://tom.mlcdn.com.br/icons/${props?.data?.iconsVersion}/font/tom-icons.ttf`,
        crossOrigin: ``,
      },
    ],
  });

export const componentsList = [
  "Preconnect",
  "Script",
  "AllIn",
  "Criteo",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Loader",
  "StateLoader",
  "EventPageViewDispatcher",
  "PageLoading",
  "Row",
  "Heading",
  "Image",
  "Button",
  "VersionTag",
  "BackToTop"
];

export const routeInfo = {
  id: '404',
  name: 'internal-not-found-page',
  pathPattern: '/error-404/',
  pathAliases: {},
  parser: {
    query: {
      "seller_id": unique(),
    },
    cookie: {},
  },
  renderMethod: 'SSR',
  forwardCookies: '',
  forwardHeaders: 'user-agent,referer,theme,x-forwarded-for'
};

export const manifest = {
  "useTypescript": true,
  "deepLinkHost": "https://m.magazineluiza.com.br",
  "isMiniApp": true
};

export const getGlobalClassName = props => ([
  ]).join(' ').trim();

export const getPageVariables = props => ({
  });

export const middlewaresArgs = ({ 
      "getAppTheme": (props) => ({
  }),
      "webViewValidator": (props) => ({
    redirectUrl: `/404/`,
  }),
      "getUserInfo": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
      "writePromoterIdCookie": (props) => ({
  }),
 });

export const config = {
  assetPrefix: '',
};
